<template>
<v-responsive width="100%">
    <v-card class="mt-4" :disabled="coupon._id">
        <v-card-title class="subtitle-2 font-weight-bold">
            <v-icon small class="mr-2">mdi-alert-circle-outline</v-icon>첫구매고객 대상
        </v-card-title>
        <v-card-text>
            <span class="caption d-block">최근 2년간 구매이력이 없는 고객을 대상으로 혜택을 설정할 수 있습니다.</span>
            <span class="caption d-block">첫구매고객을 위한 첫구매 쿠폰(다운로드) 혜택을 등록해 보세요.</span>
        </v-card-text>
    </v-card>

    <v-card class="mt-4" :disabled="coupon._id">
        <v-card-title class="subtitle-2 font-weight-bold">쿠폰명칭</v-card-title>
        <v-card-text>
            <v-text-field v-model="coupon.name" label="쿠폰 이름" placeholder=" " dense hide-details @input="$emit('input', coupon)"></v-text-field>
        </v-card-text>
    </v-card>

    <v-card class="mt-4" :disabled="coupon._id">
        <v-card-title class="subtitle-2 font-weight-bold">쿠폰종류</v-card-title>
        <v-card-text>
            <v-radio-group v-model="coupon.type" dense hide-details row class="mt-0" @input="$emit('input', coupon)">
                <v-radio label="상품할인" value="product"></v-radio>
                <v-radio label="카테고리할인" value="category"></v-radio>
                <v-radio label="배송비할인" value="delivery"></v-radio>
            </v-radio-group>

            <product-autocomplete v-if="coupon.type == 'product'" v-model="coupon.product" @input="product => { coupon._product = product._id; $emit('input', coupon) }" class="mt-4"></product-autocomplete>
            <shop-category-select v-if="coupon.type == 'category'" v-model="coupon._category" :categories="categories" @input="$emit('input', coupon)" class="mt-4"></shop-category-select>

            <span v-if="coupon.type == 'product'" class="caption primary--text d-block mt-2">즉시할인과 중복으로 사용할 수 있는쿠폰입니다.</span>
            <span v-if="coupon.type == 'delivery'" class="caption primary--text d-block mt-2">배송비 유료 상품에 배송비 묶음그룹 기준으로 사용할 수 있는 쿠폰입니다.</span>

        </v-card-text>
    </v-card>

    <v-card class="mt-4" :disabled="coupon._id">
        <v-card-title class="subtitle-2 font-weight-bold">발급방법</v-card-title>
        <v-card-text>
            <v-radio-group v-model="coupon.method" dense hide-details row class="mt-0" @input="$emit('input', coupon)">
                <v-radio label="다운로드" value="download"></v-radio>
            </v-radio-group>

            <span class="caption primary--text d-block mt-2">고객이 다운로드 버튼을 클릭하여 쿠폰을 발급받아 사용합니다.</span>
        </v-card-text>
    </v-card>

    <v-card class="mt-4" :disabled="coupon._id">
        <v-card-title class="subtitle-2 font-weight-bold">할인설정</v-card-title>
        <v-card-text>
            <v-row align="center" class="m">
                <v-col cols="6" class="py-0">
                    <v-row align="center">
                        <v-col cols="8" class="py-0">
                            <v-text-field v-model="coupon.amount" label="할인금액" placeholder=" " dense hide-details @input="$emit('input', coupon)"></v-text-field>
                        </v-col>
                        <v-col cols="4" class="py-0">
                            <v-select v-model="coupon.unit" :items="['원', '%']" label="단위" placeholder=" " dense hide-details @input="$emit('input', coupon)"></v-select>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col v-if="coupon.unit == '%'" cols="6" class="py-0">
                    <v-row align="center">
                        <v-col cols="auto" class="py-0">최대</v-col>
                        <v-col class="py-0">
                            <v-text-field v-model="coupon.maxAmount" dense hide-details @input="$emit('input', coupon)"></v-text-field>
                        </v-col>
                        <v-col cols="auto" class="py-0">원 할인</v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>

    <v-card class="mt-4" :disabled="coupon._id">
        <v-card-title class="subtitle-2 font-weight-bold">최소주문금액</v-card-title>
        <v-card-text>
            <v-row align="center">
                <v-col cols="12" sm="6" class="py-0">
                    <v-row align="center">
                        <v-col class="py-0">
                            <v-text-field v-model="coupon.minAmount" dense hide-details @input="$emit('input', coupon)"></v-text-field>
                        </v-col>
                        <v-col cols="auto" class="py-0">원 이상 구매시 사용 가능</v-col>
                    </v-row>
                </v-col>
            </v-row>

            <span class="caption primary--text d-block mt-2">· 상품중복할인과 배송비 할인 쿠폰의 최소주문금액은 판매가 기준으로 사용됩니다</span>
            <span class="caption primary--text d-block">( 예시 : 최소주문금액 1,000원 / 100원 상품중복할인 쿠폰의 경우, 판매가 1,000원 / 즉시할인가 500원인 상품 → 사용가능 / 400원에 결제 즉, 판매가 1,000원 이상이면 즉시할인가에 상관없이 사용가능 )</span>
        </v-card-text>
    </v-card>

    <v-card v-if="coupon.method == 'download'" class="mt-4" :disabled="coupon._id">
        <v-card-title class="subtitle-2 font-weight-bold">
            <v-row align="center">
                <v-col class="py-0">혜택기간</v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="py-0 pr-0 caption">특정 기간만 혜택 제공</v-col>
                <v-col cols="auto" class="py-0">
                    <v-switch v-model="coupon.download.period" dense hide-details class="ma-0 pa-0" @input="$emit('input', coupon)"></v-switch>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text v-if="coupon.download.period">
            <v-radio-group :value="getTerm(coupon.download.startDate, coupon.download.endDate)" @change="setTerm($event, coupon.download)" row dense hide-details class="ma-0 pa-0">
                <v-radio label="1주일" :value="0.25"></v-radio>
                <v-radio label="1개월" :value="1"></v-radio>
                <v-radio label="3개월" :value="3"></v-radio>
                <v-radio label="6개월" :value="6"></v-radio>
                <v-radio label="1년" :value="12"></v-radio>
            </v-radio-group>

            <v-row class="mt-4">
                <v-col>
                    <v-date-field v-model="coupon.download.startDate" label="혜택시작일자" placeholder=" " dense hide-details @input="$emit('input', coupon)"></v-date-field>
                </v-col>
                <v-col>
                    <v-date-field v-model="coupon.download.endDate" label="혜택종료일자" placeholder=" " dense hide-details @input="$emit('input', coupon)"></v-date-field>
                </v-col>
            </v-row>

            <span class="caption primary--text d-block"> 설정된 날짜부터 다운로드 가능한 쿠폰이 노출됩니다.</span>
        </v-card-text>
    </v-card>

    <v-card class="mt-4" :disabled="coupon._id">
        <v-card-title class="subtitle-2 font-weight-bold">
            <v-row align="center">
                <v-col cols="auto" class="py-0">쿠폰유효기간</v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="py-0">
                    <v-switch v-model="coupon.expiration.enabled" dense hide-details class="pa-0 ma-0" @input="$emit('input', coupon)"></v-switch>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text v-if="coupon.expiration.enabled">
            <v-radio-group v-model="coupon.expiration.type" row dense hide-details class="ma-0 pa-0" @input="$emit('input', coupon)">
                <v-radio label="기간으로설정" value="period"></v-radio>
                <v-radio label="발급일 기준으로 설정" value="days"></v-radio>
            </v-radio-group>

            <v-row v-if="coupon.expiration.type == 'period'" class="mt-6">
                <v-col class="py-0">
                    <v-date-field v-model="coupon.expiration.startDate" label="시작일자" placeholder=" " dense hide-details @input="$emit('input', coupon)"></v-date-field>
                </v-col>
                <v-col class="py-0">
                    <v-date-field v-model="coupon.expiration.endDate" label="종료일자" placeholder=" " dense hide-details @input="$emit('input', coupon)"></v-date-field>
                </v-col>
            </v-row>

            <div v-if="coupon.expiration.type == 'period'" class="caption primary--text mt-3">특정 기간동안 쿠폰 유효</div>
            <v-row v-if="coupon.expiration.type == 'days'" align="center" class="mt-6">
                <v-col cols="12" sm="6" class="py-0">
                    <v-row align="center">
                        <v-col cols="auto" class="py-0">발급일로부터</v-col>
                        <v-col class="py-0">
                            <v-text-field v-model="coupon.expiration.days" dense hide-details @input="$emit('input', coupon)"></v-text-field>
                        </v-col>
                        <v-col cols="auto" class="py-0">일 간 유효</v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>

</v-responsive>
</template>

<script>
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import ShopCategorySelect from "@/components/console/shop/categories/shop-category-select.vue";
import ProductAutocomplete from "@/components/console/shop/products/product-autocomplete.vue";

export default {
    components: {
        VDateField,
        ShopCategorySelect,
        ProductAutocomplete
    },
    props: {
        value: { type: Object, default: null },
        categories: { type: Array, default: null }
    },
    data(){
        return {
            coupon: this.$props.value || {
                _id: null,
                _product: null,
                _category: null,

                name: null,
                kind: "firstPurchaseCoupon",
                type: 'product',
                amount: 0,
                unit: '원',
                maxAmount: 0,
                minAmount: 0,

                method: 'download',
                download: {
                    period: false,
                    startDate: null,
                    endDate: null
                },
                expiration: {
                    enabled: false,
                    type: 'period',
                    startDate: null,
                    endDate: null,
                    days: 0
                }
            }
        };
    },
    methods: {
        getTerm(startDate, endDate){
            var date1 = new Date(startDate);
            var date2 = new Date(endDate);
            date1.addDate(-1);
            if(new Date(date1).addDate(7) == date2.getTime()) return 0.25;
            else if(new Date(date1).addMonth(1) == date2.getTime()) return 1;
            else if(new Date(date1).addMonth(3) == date2.getTime()) return 3;
            else if(new Date(date1).addMonth(6) == date2.getTime()) return 6;
            else if(new Date(date1).addYear(1) == date2.getTime()) return 12;
        },
        setTerm(value, target){
            var startDate = new Date();
            var endDate = new Date();
            endDate.addDate(-1);
            switch(value){
                case 0.25: endDate.addDate(7); break;
                case 1: endDate.addMonth(1); break;
                case 3: endDate.addMonth(3); break;
                case 6: endDate.addMonth(6); break;
                case 12: endDate.addYear(1); break;
            }
            target.startDate = startDate.getTime().toDate();
            target.endDate = endDate.getTime().toDate();
        }
    },
    watch: {
        value(){
            if(this.value) this.coupon = this.value;
        },
        "coupon.type"(){
            if (this.coupon.type == "product") this.coupon._category = null;
            if (this.coupon.type == "category") this.coupon._product = null;
            if (this.coupon.type == "delivery") {
                this.coupon._category = null;
                this.coupon._product = null;
            }
        }
    }
}
</script>
